import { create } from "zustand"

/**
 * Where the search was opened from: the top-bar trigger (or ⌘K) on desktop,
 * or the icon on mobile. Both open the same dialog, which adapts to the
 * viewport with CSS alone, so this records the entry point rather than
 * deciding the presentation.
 */
type OpenedFrom = "field" | "icon"

interface GlobalSearchState {
  isOpen: boolean
  openedFrom: OpenedFrom | null
  openFromField: () => void
  openFromIcon: () => void
  close: () => void
}

export const useGlobalSearchStore = create<GlobalSearchState>()((set) => ({
  isOpen: false,
  openedFrom: null,
  openFromField: () => set({ isOpen: true, openedFrom: "field" }),
  openFromIcon: () => set({ isOpen: true, openedFrom: "icon" }),
  close: () => set({ isOpen: false, openedFrom: null }),
}))
